'use client';

import type { HeadingBlock } from '@impact/types';
import type { ElementType } from 'react';

interface Props {
  block: HeadingBlock;
  editing?: boolean;
}

type HeadingLevel = 'h1' | 'h2' | 'h3' | 'h4';

const headingSizes: Record<HeadingLevel, string> = {
  h1: 'text-[clamp(3rem,12vw,9rem)] font-black',
  h2: 'text-[clamp(2.5rem,10vw,7rem)] font-black',
  h3: 'text-[clamp(2rem,8vw,5rem)] font-black',
  h4: 'text-[clamp(1.5rem,6vw,4rem)] font-black',
};

/**
 * Oversized variant: huge display type, centered, tight leading
 */
export function HeadingOversized({ block, editing }: Props) {
  const { text, level, subtitle } = block.data;
  const Tag = level as ElementType;

  return (
    <div className="my-12 text-center">
      <Tag
        className={`${headingSizes[level as HeadingLevel]} leading-[0.9] tracking-tight text-foreground uppercase`}
        {...(editing ? { 'data-editable': 'data.text' } : {})}
      >
        {text}
      </Tag>
      {subtitle ? (
        <p
          className="mt-6 text-base text-muted-foreground max-w-xl mx-auto"
          {...(editing ? { 'data-editable': 'data.subtitle' } : {})}
        >
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}
